import React from 'react';
import { useDispatch } from 'react-redux';
import addTodo from '../redux/todos/thunk/addTodo';
import updateBook from '../redux/todos/thunk/updateBook';

const AddBookForm = ({bookInputs,setbookInputs,isUpdate,setIsUpdate}) => {

  
 
const dispatch =useDispatch()
const inputHandler = (event)=>{
const{name,type,value}=event.target;
setbookInputs({...bookInputs,[name]: type=="checkbox" ? event.target.checked ? true :false  : value })


}
const submitForm =(e)=>{
    e.preventDefault();

if(bookInputs?.id){
  dispatch(updateBook(bookInputs?.id,bookInputs));

}else{

  dispatch(addTodo(bookInputs));
}

    setbookInputs({
        name:"",
        author:"",
        thumbnail:"",
        price:0,
        rating:0,
        featured:false
    })
    setIsUpdate(false)
}

  return (
    <> <div className="p-4 overflow-hidden bg-white shadow-cardShadow rounded-md">
    <h4 className="mb-8 text-xl font-bold text-center">Add New Book</h4>
    <form className="book-form" onSubmit={submitForm}>
      <div className="space-y-2">
        <label htmlFor="name">Book Name</label>
        <input required className="text-input" type="text" id="input-Bookname" name="name" value={bookInputs?.name} onChange={e=>inputHandler(e)} />
      </div>
      <div className="space-y-2">
        <label htmlFor="category">Author</label>
        <input required className="text-input" type="text" id="input-Bookauthor" name="author" value={bookInputs?.author} onChange={e=>inputHandler(e)} />
      </div>
      <div className="space-y-2">
        <label htmlFor="image">Image Url</label>
        <input required className="text-input" type="text" id="input-Bookthumbnail" name="thumbnail"  value={bookInputs?.thumbnail} onChange={e=>inputHandler(e)} />
      </div>
      <div className="grid grid-cols-2 gap-8 pb-4">
        <div className="space-y-2">
          <label htmlFor="price">Price</label>
          <input required className="text-input" type="number" id="input-Bookprice" name="price"  value={bookInputs?.price} onChange={e=>inputHandler(e)} />
        </div>
        <div className="space-y-2">
          <label htmlFor="quantity">Rating</label>
          <input required className="text-input" type="number" id="input-Bookrating" name="rating"  value={bookInputs?.rating} onChange={e=>inputHandler(e)} min={1} max={5} />
        </div>
      </div>
      <div className="flex items-center">
        <input id="input-Bookfeatured"  value={bookInputs?.featured} checked={bookInputs?.featured} onChange={e=>inputHandler(e)} type="checkbox" name="featured" className="w-4 h-4" />
        <label htmlFor="featured" className="ml-2 text-sm"> This is a featured book </label>
      </div>
      <button type="submit" className="submit" id="submit"> {bookInputs?.id ? "Update" :"Add"} Book</button>
    </form>
  </div></>
  )
}

export default AddBookForm